module.exports = __webpack_public_path__ + "img/0Q3B3739_L_BlackMatted_MockedUp.9dad8441.jpg";